import { PropsWithChildren } from "react";
import {
  accentColor,
  formTitle,
  sectionTitle,
  accentTitleWrapper,
} from "./styles.css";

export const SectionTitle = ({ children }: PropsWithChildren) => (
  <h2 className={sectionTitle}>{children}</h2>
);

export const FormTitle = ({ children }: PropsWithChildren) => (
  <h2 className={formTitle}>{children}</h2>
);

export const AccentText = ({ children }: PropsWithChildren) => (
  <span className={accentColor}>{children}</span>
);

// #TODO: recreate components with their styles
export const AccentTitle = ({ children }: PropsWithChildren) => (
  <div className={accentTitleWrapper}>
    <p className={accentColor}>{children}</p>
  </div>
);
